import { logBase } from '../../../../../shared/misc-utilities/misc-utils';
// @ts-ignore
import { KOptions, SLICO } from '../js-segment-annotator-code/slico';
import { AbstractAlgorithmAdapter } from './abstract-algorithm-adapter';

/**
 * The smallest we want a superpixel to be (roughly). This is 10x10.
 */
const smallestRegionSize = 10;
const defaultNumberOfSuperpixels = 2000;
const minNumberOfSuperpixels = 50;

const sizeAdjustFactor = 2;

export class SLICOAdapter extends AbstractAlgorithmAdapter<KOptions> {
  readonly name = 'SLICO';

  get minRelativeSize() {
    const smallestArea = smallestRegionSize * smallestRegionSize;
    const maxNumberOfSuperpixels = this.imageArea / smallestArea;
    return Math.ceil(
      -logBase(
        sizeAdjustFactor,
        maxNumberOfSuperpixels / defaultNumberOfSuperpixels,
      ),
    );
  }

  get maxRelativeSize() {
    return Math.floor(
      logBase(
        sizeAdjustFactor,
        defaultNumberOfSuperpixels / minNumberOfSuperpixels,
      ),
    );
  }

  protected executeAlgorithm(options: KOptions) {
    // @ts-ignore
    return new SLICO(this.image, options).result;
  }

  protected defaultOptions() {
    return this.options(defaultNumberOfSuperpixels);
  }

  protected adjustForSmallerSuperpixels({ K }: KOptions) {
    return this.options(K * 2);
  }

  protected adjustForBiggerSuperpixels({ K }: KOptions) {
    return this.options(K / 2);
  }

  private options(K: number): KOptions {
    return { method: 'FixedK', K: Math.round(K) };
  }
}
